module.exports = __webpack_public_path__ + "static/media/proximanova-medium.60d729a5.otf";